import React from 'react';

class Select extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    if(!this.props.data.hide)
    {  
      return (
        <div className={"form-item" + (this.props.data.isSmall ? " small" : "") + (this.props.data.validationRules.isRequired ? " required" : "") + (this.props.data.isHalf ? " half" : "") + (this.props.data.isHalfStart ? " half-start" : "")}>
          {this.props.data.label &&
            <label>{this.props.data.label}</label>
          }      
          <div className="select-container">
              <select name={this.props.data.name} value={this.props.data.value} disabled={this.props.data.disabled} onChange={this.handleChange}>
                  <option value=''>{this.props.data.placeholder}</option>
                  {this.props.data.options && this.props.data.options.map((item, i) =>
                    <option value={item.value}>{item.name}</option>
                  )}
              </select>
          </div>
          {this.props.data.touched && !this.props.data.valid && 
            <div className="form-error">
              {this.props.data.error}
            </div>
          }
        </div>
      );
    }
    else {
      return (<div></div>)
    }
  }

    handleChange = e => {
      if(this.props.data.handleChange){
         return this.props.data.handleChange(e, (this.props.index ? this.props.index : 0))
      }
        else{
          return this.props.handleChange(e, (this.props.index ? this.props.index : 0))
      }
    }
}
  
  export default Select;